import '@mdi/font/css/materialdesignicons.css';

import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import {THEME} from '@/site/constants';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {light: THEME},
    options: {
      customProperties: true,
    },
  },
});
